export default function requestStatus(res) {
  if (res.code != 0) {
    console.log("====")
    this.$bus.$emit('showPopup', {
      name: 'tip',
      data: res.msg,
    });
  }
}



// WEBPACK FOOTER //
// ./src/lib/requestConf/requestStatus.js